import { Link, createFileRoute } from '@tanstack/react-router'

import {useEffect, useMemo, useState} from 'react'
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {Button} from '@/components/ui/button'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {toast} from 'sonner'
import UserFilter from '@/components/user-filter'
import OperatorsIcon from '@/components/OperatorIcons'
import {  Check, Copy, Eye, Loader2, X, } from 'lucide-react'
import PrintableTransaction from '@/components/printable-transaction'
import NumberWithHoverPoints from '@/components/NumberWithHoverPoint'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { type PaginationState, type RowSelectionState } from '@tanstack/react-table'
import { TransactionDetails, type Transaction } from '@/types'
import { DataTable } from '@/components/ui/data-table'
import type { OperatorsName } from '@/stores/operator-store'
import { useMutation } from '@tanstack/react-query'
import { getOrderById } from '@/queries/orders'
import BatchPrint from '@/components/batch-print'
import { Badge } from '@/components/ui/badge'


export const Route = createFileRoute('/client/transactions/')({
  component: ClientWalletTransactions,
})



// Extended transaction interface with subRows for React Table
export interface TransactionWithSubRows extends Transaction {
  subRows?: Transaction[];
}

const getProductLabel = (transaction: any) => {
  if (transaction.product_type === 'card_charge') return 'کارت شارژ'
  if (transaction.product_type === 'td_lte_internet') {
    return transaction.product_name?.replace('- دائمی', '') || '-'
  }
  return transaction.product_name || '-'
}

const getDetailLabel = (transaction: any) => {
  if (transaction.detail === 'decrease_purchase_buyer') {
    const labels: Record<string, string> = {
      cell_internet: 'بسته اینترنت',
      cell_direct_charge: 'شارژ مستقیم',
      td_lte_internet: 'بسته TD LTE',
      card_charge: 'کارت شارژ',
      cart: 'خرید از فروشگاه',
    }
    return labels[transaction.product_type] || '-'
  }

  return TransactionDetails[transaction.detail as keyof typeof TransactionDetails] || '-'
}

const isTransactionSuccessful = (transaction: any) => {
  let successful = transaction.status === 'confirmed'

  if (transaction.third_party_status !== null) {
    if (transaction.third_party_status !== 1) successful = false
  } else if (transaction.detail === 'decrase_purchase_buyer') {
    successful = false
  }

  return successful
}

function TransactionInfo({transaction}: {transaction: any}) {
  const [open, setOpen] = useState(false)
  const [orderables, setOrderables] = useState<Array<any>>([])
  const orderMutation = useMutation({
    mutationFn: () => getOrderById(transaction.order_id),
    mutationKey: ['order', transaction.order_id],
    onSuccess({data}) {
      setOrderables(data.orderables)
    },
  })

  return (
    <Popover
      open={open}
      onOpenChange={(nextOpen) => {
        if (nextOpen && transaction.product_type === 'card_charge') {
          orderMutation.mutate()
        }
        setOpen(nextOpen)
      }}
    >
      <PopoverTrigger asChild>
        <Button
          size='icon'
          variant='outline'
          className='size-9'
          aria-label='مشاهده اطلاعات تراکنش'
          title='مشاهده اطلاعات تراکنش'
        >
          <Eye className='size-4' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='flex w-80 max-w-[calc(100vw-1rem)] flex-col gap-4 divide-y divide-border'>
        <div className='flex items-center justify-between gap-2'>
          <span dir='ltr' className='min-w-0 break-all text-right text-xs tabular-nums'>
            {transaction.resnumber || '-'}
          </span>
          <Button
            size='icon'
            variant='ghost'
            className='size-8 shrink-0'
            aria-label='کپی شماره پیگیری'
            title='کپی شماره پیگیری'
            onClick={() => {
              if ('clipboard' in navigator) {
                navigator.clipboard.writeText(transaction.resnumber)
                toast.success('کپی شد')
              }
            }}
          >
            <Copy className='size-4' />
          </Button>
        </div>
        {transaction.order_id && (
          <div className='flex items-center justify-between gap-3 pt-4'>
            <p className='font-bold'>شماره سفارش</p>
            <span>{transaction.order_id}</span>
          </div>
        )}
        {transaction.extra_info?.ip && (
          <div className='flex items-center justify-between gap-3 pt-4'>
            <p className='font-bold'>IP</p>
            <span dir='ltr'>{transaction.extra_info.ip}</span>
          </div>
        )}
        {transaction.product_type === 'card_charge' && (
          <div className='pt-4'>
            {orderMutation.isPending ? (
              <div className='flex items-center gap-2'>
                <Loader2 className='size-4 animate-spin' />
                <p>در حال بارگذاری ...</p>
              </div>
            ) : (
              <div className='space-y-2'>
                <div className='flex justify-between font-bold'>
                  <p>محصول</p>
                  <p>تعداد</p>
                </div>
                {orderables.map(order => (
                  <div key={order.id} className='flex justify-between gap-3 text-sm'>
                    <span>{order.name}</span>
                    <span>{order.pivot.quantity}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </PopoverContent>
    </Popover>
  )
}

function ClientWalletTransactions () {
  // const [searchedData, setSearchedData] = useState<any>(null)
  const [filtered,setFiltered] = useState<any>()
  const [meta, setMeta] = useState<any>()
  const [showTransaction, setShowTransaction] = useState(false)
  const [pagination, setPagination] = useState<PaginationState>({pageIndex: 0, pageSize: 10})
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({})
  const [selectedRow, setSelectedRow] = useState<Array<any>>([])

  useEffect(()=> {
    if (filtered) {

      const allData = [...selectedRow, ...filtered]
      console.log(allData)
      const selectedRows = Object.keys(rowSelection).map(key => {
        return allData.find((item:any) => {
          if (item.id == key) {
            return true
          }
        })
      }).filter(Boolean)
      
      
      
      setSelectedRow(selectedRows)
    }
}, [rowSelection,filtered])

// Process transactions by order_id: adjust wallet_after_transaction, drop refunds, sort, and return flat list
const groupTransactionsByOrderId = (transactions: Transaction[]): Transaction[] => {
  // 1) Group by order_id (fallback to id if missing)
  const orderGroups = new Map<number | undefined, Transaction[]>();
  transactions.forEach(tx => {
    const key = tx.order_id ?? tx.id;
    if (!orderGroups.has(key)) {
      orderGroups.set(key, []);
    }
    // clone so we don’t mutate originals
    orderGroups.get(key)!.push({ ...tx });
  });

  // 2) Process each group
  const result: Transaction[] = [];
  orderGroups.forEach(group => {
    // a) Find matching refund/purchase pair
    const inc: any = group.find(t => t.detail === 'increase_refund');
    const dec: any = group.find(t => t.detail === 'decrease_purchase_buyer');
    if (inc && dec) {
      dec.wallet_value_after_transaction = inc.wallet_value_after_transaction;
    }

    // b) Remove all increase_refund entries
    const filtered = group.filter(t => t.detail !== 'increase_refund');

    // c) Sort so decrease_purchase_buyer comes first
    filtered.sort((a, b) => {
      if (a.detail === 'decrease_purchase_buyer') return -1;
      if (b.detail === 'decrease_purchase_buyer') return 1;
      return 0;
    });

    // d) Append to flat result
    result.push(...filtered);
  });

  return result;
};


  const handleChangeFilter = (data: any) => {
    if (!data) {
      setFiltered(null)
      setSelectedRow([])
    } else {
      const grouped = groupTransactionsByOrderId(data)
      setFiltered(grouped)
    }
  }

  const columns:any = [
    {
      header: 'خرید و مشترک',
      id: 'purchase',
      cell: ({row}: any) => {
        const transaction = row.original
        const operatorName = transaction.extra_info?.operator?.name?.toLowerCase()

        return (
          <div className='space-y-2 text-xs leading-5'>
            <div className='flex items-start gap-2'>
              {operatorName && (
                <OperatorsIcon
                  operator={operatorName as OperatorsName}
                  className='size-8 shrink-0'
                  operatorColors
                />
              )}
              <div className='min-w-0 space-y-1'>
                <Badge
                  variant='outline'
                  className='max-w-full whitespace-normal border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-800 dark:bg-sky-950/40 dark:text-sky-300'
                >
                  {getDetailLabel(transaction)}
                </Badge>
                <div className='break-words font-medium'>{getProductLabel(transaction)}</div>
              </div>
            </div>
            <div className='space-y-0.5 border-r border-border pr-2'>
              <div dir='ltr' className='text-right tabular-nums'>
                {transaction.charged_mobile?.replace('98', '0') || '-'}
              </div>
              <div className='text-muted-foreground'>
                مخاطب: <span className='text-foreground'>{transaction.extra_info?.phone_book_name || '-'}</span>
              </div>
            </div>
            <div className='flex flex-wrap items-center gap-2'>
              <TransactionInfo transaction={transaction} />
              <div title='چاپ تراکنش'>
                <PrintableTransaction transaction={transaction}/>
              </div>
            </div>
          </div>
        )
      },
    },
    {
      header: 'مبالغ',
      id: 'amounts',
      cell: ({row}: any) => {
        const transaction = row.original

        return (
          <div className='space-y-2 text-xs leading-5'>
            <div className='rounded-md border border-amber-200 bg-amber-50/80 p-2 dark:border-amber-900 dark:bg-amber-950/30'>
              <Badge className='mb-1 max-w-full whitespace-normal break-words px-1.5 text-center leading-4 border-amber-300 bg-amber-100 text-amber-800 dark:border-amber-700 dark:bg-amber-900/60 dark:text-amber-200'>
                قیمت محصول
              </Badge>
              <div className='font-semibold text-amber-900 dark:text-amber-100'>
                {transaction.original_price != null
                  ? <NumberWithHoverPoints number={transaction.original_price || 0}/>
                  : '-'}
              </div>
            </div>
            <div className='rounded-md border border-sky-200 bg-sky-50/80 p-2 dark:border-sky-900 dark:bg-sky-950/30'>
              <Badge className='mb-1 max-w-full whitespace-normal break-words px-1.5 text-center leading-4 border-sky-300 bg-sky-100 text-sky-800 dark:border-sky-700 dark:bg-sky-900/60 dark:text-sky-200'>
                مقدار تراکنش
              </Badge>
              <div className='font-semibold text-sky-900 dark:text-sky-100'>
                <NumberWithHoverPoints number={transaction.value || 0} />
              </div>
            </div>
            <div className='rounded-md border border-border bg-muted/40 p-2'>
              <Badge variant='secondary' className='mb-1 max-w-full whitespace-normal'>
                موجودی بعد از تراکنش
              </Badge>
              <div className='font-semibold'>
                <NumberWithHoverPoints number={transaction.wallet_value_after_transaction || 0} />
              </div>
            </div>
          </div>
        )
      },
    },
    {
      header: 'وضعیت و زمان',
      id: 'result',
      cell: ({row}: any) => {
        const transaction = row.original
        const successful = isTransactionSuccessful(transaction)
        const date = new Date(transaction.created_at)
        return (
          <div className='space-y-2 text-xs leading-5'>
            <Badge
              className={successful
                ? 'border-green-300 bg-green-100 text-green-800 dark:border-green-700 dark:bg-green-900/60 dark:text-green-200'
                : 'border-red-300 bg-red-100 text-red-800 dark:border-red-700 dark:bg-red-900/60 dark:text-red-200'
              }
            >
              {successful ? <Check /> : <X />}
              {successful ? 'موفق' : 'ناموفق'}
            </Badge>
            <div className='rounded-md border border-border bg-muted/40 p-2'>
              <div className='text-muted-foreground'>تاریخ تراکنش</div>
              <div dir='ltr' className='text-right tabular-nums'>
                <div>{Intl.DateTimeFormat('fa-ir', {dateStyle: 'short'}).format(date)}</div>
                <div>{Intl.DateTimeFormat('fa-ir', {timeStyle: 'short'}).format(date)}</div>
              </div>
            </div>
          </div>
        )
      },
    },
  ]

  const data = useMemo(()=> {
    if (!filtered) return []
    return filtered
  }, [filtered])

  return (
    <>
      <Dialog open={showTransaction} onOpenChange={(o) => setShowTransaction(o)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>جزئیات تراکنش</DialogTitle>
          </DialogHeader>
        </DialogContent>
      </Dialog>

      <Card>
        <div className='flex flex-wrap items-center justify-between gap-2'>
          <CardHeader className='p-3 lg:p-6'>
            <CardTitle className='text-base lg:text-2xl'>تراکنش‌ها</CardTitle>
          </CardHeader>
          <Link to='/'>
            <Button className='m-3 lg:m-4'>بازگشت</Button>
          </Link>
        </div>

        <CardContent className='p-2 pt-0 lg:p-6 lg:pt-0'>
        <UserFilter setFiltered={handleChangeFilter}
        filtered={filtered} excelEnable setMeta={setMeta}  page={pagination.pageIndex} perPage={pagination.pageSize}/>
          {selectedRow.length> 0 && 
          <div className='sticky top-24 z-10 flex flex-col gap-3 border-t border-border bg-card p-2 md:flex-row md:items-center md:justify-between'>
          <div className='flex flex-wrap items-center gap-2'>
            <Badge variant='secondary' className='px-3 py-1'>
              موارد انتخاب‌شده: {selectedRow.length}
            </Badge>
            <BatchPrint rows={selectedRow}/>
          </div>

          <div className='grid w-full grid-cols-1 gap-2 text-sm sm:grid-cols-2 md:w-auto'>
            <div className='rounded-md border border-amber-200 bg-amber-50/80 p-2 text-amber-900 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-100'>
              <Badge className='mb-1 max-w-full whitespace-normal break-words px-1.5 text-center leading-4 border-amber-300 bg-amber-100 text-amber-800 dark:border-amber-700 dark:bg-amber-900/60 dark:text-amber-200'>
                مجموع قیمت محصول
              </Badge>
              <div><NumberWithHoverPoints number={selectedRow.reduce((acc, curr) => acc + Number(curr.original_price),0)} /></div>
            </div>
            <div className='rounded-md border border-sky-200 bg-sky-50/80 p-2 text-sky-900 dark:border-sky-900 dark:bg-sky-950/30 dark:text-sky-100'>
              <Badge className='mb-1 max-w-full whitespace-normal break-words px-1.5 text-center leading-4 border-sky-300 bg-sky-100 text-sky-800 dark:border-sky-700 dark:bg-sky-900/60 dark:text-sky-200'>
                مجموع مقدار
              </Badge>
              <div><NumberWithHoverPoints number={selectedRow.reduce((acc, curr) => acc + Number(curr.value),0)} /></div>
            </div>
          </div>
          </div>
          
          }
          {filtered && <div className='[&_table]:table-fixed [&_thead]:bg-muted/70 [&_th]:h-10 [&_th]:px-2 [&_td]:p-2 [&_th:first-child]:w-10 [&_td:first-child]:w-10'>
          <DataTable
            columns={columns}
            data={data}
            enableRowSelection
            rowSelection={rowSelection}
            onRowSelectionChange={setRowSelection}
            pageCount={meta?.last_page || 0}
            totalDataCount={meta?.total || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
          />
          </div>}
        </CardContent>
      </Card>
    </>
  )
}
